/* Used to stretch and shrink timecode values. e.g. multiplier: 1.001, 0.999 */
export default (function tcMultiply(eventGroup, multiplier) {
  eventGroup.events.forEach((event, index, events) => {
    events[index].start = event.start * multiplier;
    events[index].end = event.end * multiplier;
  });
  return eventGroup;
});